"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/** reduce que transforma un array con ids en objetos con ese id y contenido
 * @example
 * [
 *   { id: 'header', name: 'headerHomepage'},
 *   { id: 'guardia', name: 'nombre'},
 *   { id: 'test', name: 'algo'}
 * ]
 * // luego del reduce
 * const result = {
 *   header: { name : 'headerHomepage'},
 *   guardia: { name: 'nombre' },
 *   test: { name: 'algo'}
 * }
 * // Notese como el objeto pierde la propiedad id y pasa a ser parte de su nombre
 *
 */
const reduceParameters = (prev, parameter) => {
    const { id, ...parameterWithoutId } = parameter;
    const newParameter = { [id]: parameterWithoutId };
    return { ...prev, ...newParameter };
};
/**
 *
 * @param country country
 * @param coverage corporate_norm from db
 * @param queryOptions options from react-query
 * @returns
 */
function useHomeParameters(firestore, country, coverage, queryOptions) {
    const path = (!coverage || coverage === "UMA AR" || coverage === "UMA MX" || coverage === "SIN OBRA SOCIAL (UMA)" || coverage === "DESCONOCIDA") ? `/parametros/${country}/home` : `/corporate/${coverage}/home`;
    const homeParametersRef = (0, firestore_2.collection)(firestore, path);
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Params({
        name: "homeParameters",
        path: path
    }, [country, coverage]), homeParametersRef, {}, {
        ...queryOptions,
        select(parameters) {
            if (!parameters || Object.keys(parameters).length === 0) {
                return undefined;
            }
            const orderParameters = parameters.sort((a, b) => a.order - b.order);
            return orderParameters.reduce(reduceParameters, {});
        },
    });
}
exports.default = useHomeParameters;
